export const exportHeaders = [
    {
        label: "Shipto",
        key: "customer_account_number"
    },

    {
        label: "Billto",
        key: "customer_billto_account_number"
    },


    {
        label: "Shipto Name",
        key: "customer_name"
    },

    {
        label: "Type Code",
        key: "customer_account_type_code"
    },

    {
        label: "Status",
        key: "customer_status_code"
    },
    {
        label: "Sales Division",
        key: "customer_sales_division_code"
    },
    {
        label: "Market Class",
        key: "market_class_code"
    },

    {
        label: "Segment",
        key: "segment_code"
    },

    {
        label: "Qualified Flag",
        key: "qualified_account_flag"
    },

    {
        label: "Enrollable",
        key: "type"
    }

    
]